import {
  RELATION__JOBS_STARRED
} from '../../../dictionaries/Relations.dic';
import {
  NOT
} from '../../../lib/Boolean.lib';
import Core from '../../../lib/Core';
import globalErrorHandler from '../../../lib/Error/globalErrorHandler.fun';
import useState from '../../../lib/hooks/useState.hook';
import Job from '../../../lib/Job';
import {
  mapJob
} from '../../../lib/models/job';
import {
  Obj
} from '../../../lib/Object.lib';
import {
  COLLECTION__JOBS,
  readLoopbackRecord
} from '../../../lib/services/BE/loopback.api';
import Icon from '../../Layout/Wrappers/Icon';
import Menu from '../../Layout/Wrappers/Menu';
import Once from '../../Layout/Wrappers/Once';
import Typography from '../../Layout/Wrappers/Typography';

export default function ActionStarJob({
  acl = true,
  jobId = '',
}) {
  const [state, updateState] = useState();

  if (NOT(acl) || NOT(jobId)) { return null; }

  const OBJ__JOB = Obj(state.job);

  const fetchJob = async () => {
    try {
      updateState({
        job: Obj(
          await readLoopbackRecord({
            collection: COLLECTION__JOBS,
            where: { id: jobId },
            fields: ['id'],
            include: {
              relation: RELATION__JOBS_STARRED,
              scope: {
                where: { accountId: Core.getUserId() },
                limit: 1
              },
            },
            limit: 1,
            mapper: mapJob
          })
        )
      });
    }
    catch (error) {
      globalErrorHandler(error);
    }
  }
  return (
    <Menu.Item
      onClick={async (event) => {
        event.stopPropagation();
        try {
          const response = await Job.updateStarred(
            OBJ__JOB.id,
            OBJ__JOB.starredId,
            !OBJ__JOB.starred
          );
          OBJ__JOB.starred = response.starred;
          updateState({
            job: OBJ__JOB
          });
        }
        catch (error) {
          globalErrorHandler(error);
        }
      }}
      divider
    >
      <Once
        promise={fetchJob}
        render={false}
      />
      <Typography mr>
        Star job
      </Typography>
      <Icon
        icon={OBJ__JOB.starred ? 'star' : 'star_border'}
        className='c-gray'
      />
    </Menu.Item>
  );
}

